interface Thumbnail {
  href: string;
  altText: string;
}

interface Metadata {
  titleDisplay: string;
  descriptionDisplay: string;
  language: string;
  audience: string[];
  taxonomy: unknown[];
  contentType: string;
}

interface Product {
  code: string;
  name: string;
  contentPackName: string;
}

interface Audience {
  id: number;
  audience: string;
}

interface Keyword {
  id: number;
  keyword: string;
}

interface Contributor {
  id: number;
  firstName: string;
  lastName: string;
  role: string;
}

interface Taxon {
  id: number;
  name: string;
  code: string;
  taxonomyId: number;
  taxonomyName: string;
  path: {
    id: number;
    name: string;
    code: string;
  }[];
}

interface TaxonomyType {
  id: number;
  name: string;
  taxa: Taxon[];
}

export interface Content {
  pcmId: string;
  titleDisplay: string;
  titleSearchable: string;
  descriptionDisplay: string;
  descriptionSearchable: string;
  products: Product[];
  taxonomyTypes: TaxonomyType[];
  assetType: string;
  assetTypeLabel: string;
  assetTypeModel: string;
  contentType: string;
  contentTypeLabel: string;
  audiences: Audience[];
  keywords: Keyword[];
  language: string;
  metadataLanguage: string;
  filename: string;
  metadataHref: string;
  ageMin: number;
  ageMax: number;
  gradeMin: string;
  gradeMax: string;
  contributors: Contributor[];
  isFiction: boolean;
  subtitle?: string;
}

export interface Bundle {
  id: string;
  thumbnail: Thumbnail;
  metadata: Metadata;
  contents: Content[];
}

export interface Group {
  assets: Content[];
  metadata?: Metadata;
}

export interface BundleById {
  id: string;
  thumbnail: Thumbnail;
  metadata: Metadata;
  groups: Group[];
}

export interface Application {
  applicationCode: string;
  applicationTitle: string;
  productCodes: string[];
  iconSrc: string;
  nativeApplication: boolean;
  groupCode?: string;
}

const apiBaseUrl = '/api/composite/v1';

export const fetchApplications = async () => {
  const response = await fetch(
    `${apiBaseUrl}/applications?includeNonNative=true`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch user applications');
  }
  return (await response.json()) as Application[];
};
